(function () {
    "use strict";

    checkScreenSize();

    $(document).ready(function () { main(); });

    $(window).on("load", function () {
        $("#BioPicture").removeClass("blur");
    });

    function main() {
        checkDropCapLetter();
        
        stripSizeAttr();
        
        addBlogMenu();
        addLegalAreasMenu();
        
        $("[data-elmtooltip]").elmToolTip();
       
        var toc = new UlToc({ debug: false,
                              outputcontainerid: "#PageTOC",
        });

        if ($("li", "#PageTOC").length > 0) {
            setTimeout(function () { displayTOC(); }, 500);
        }

        setupNavigation();
        setupSocialBox();
        setupSearchBox();
        setupLangBox();
        setupShareBox();
        
        $(".button-click-anim").click(function () {
            $(this).addClass("click");
            
            $(this).one('animationend webkitAnimationEnd MSAnimationEnd oAnimationEnd',   
                function () {
                    $(this).removeClass("click");
            });            
        });

        $("#OpenLogoBarButton").click(function() {
            $("#LogoBar").toggleClass("open");
        });

        var logobarscroller = new ElmScroller({
            window: window,
            document: document,
            element: $("#LogoBar .logobar-items"),
            elementparent: $("#LogoBar .logobar-wrap"),
            direction_y: true
        });         
        
        $("#ScrollTopButton").click(function () { scrollTo("body"); });

        $("#ArticleList article").click(function (ev) {
            var elem = ev.target || ev.srcElement;

            // Do nothing if clicked on a link
            if (elem.tagName.toLowerCase() != "a" && elem.parentNode.tagName.toLowerCase() != "a") {
                window.location.href = $("a", $("h2", this)).attr("href");
            }
         });
        
        setupTeamSlide();        
        setupOfficeSlide();     
        
        setupHighSlideImages("#Content");

        //placeDropCap();

        onDocumentPosUpdate();

        startIntroAnimation();

        // Animate infotip for language button        
        if ($(".lang-button-tip").length > 0) {
            $(".lang-button-tip").css("display", "block");

            TweenMax.fromTo(".lang-button-tip", 1, { opacity: 0, x: 50 }, {
                opacity: 1, x: 0, ease: Quad.easeOut, delay: 2,
                onComplete: function () {
                    TweenMax.fromTo(".lang-button-tip", 0.5, { opacity: 1, scale: 1 }, {
                        opacity: 0, scale: 0, ease: Quint.easeIn, delay: 4,
                        onComplete: function () { 
                            $(".lang-button-tip").remove();
                        }
                    });
                }
            });
        }
        
        $(window).resize(function () {
            onDocumentPosUpdate();
        });
        
        $(window).scroll(function () {
            onDocumentPosUpdate();
        });        
    }

    function startIntroAnimation() {
        // Are we on homepage?
        if ($("#Splash").length === 0) { return; }

        // The following two variables dynamically defined in html
        // var ikeywords = ["Gelijkwaardigheid", "Stabiliteit", "Continuïteit", "Innovatie", "Klantvriendelijkheid"];
        // var iimages = ["images/splash1.jpg", "images/splash2.jpg", "images/splash3.jpg", "images/splash4.jpg"];

        if (typeof ikeywords == 'undefined' || ikeywords.length <= 0 ||
            typeof iimages == 'undefined' || iimages.length <= 0) {
            return;
        }

        var wtimer = null;        
        var atkw = 0;
        var atimg = 0;

        var timg = $('<img id="SplashLoadImg" src="" style="position:absolute;height:10px;width:10px;visibility:hidden"><img id="SplashPreLoadImg" src="" style="position:absolute;height:10px;width:10px;visibility:hidden">');
        $("#Splash").append(timg);

        $("#SplashLoadImg").on("load", function () { onImageLoaded(); });

        TweenMax.set("#SplashSVGGray", { opacity: 0 });        
        TweenMax.set("#SplashSVGGreen", { opacity: 0 });
        TweenMax.set("#clipPath2 rect", { attr: { width: "0%" } });

        nextSlide();
        
        function nextSlide() {
            wtimer = setTimeout(function () {
                TweenMax.fromTo("#SplashWait", 1, { opacity: 0 }, { opacity: 1, ease: Quad.easeOut });
            }, 1000);
            
            var nextimg = atimg + 1;
            if (nextimg >= iimages.length) { nextimg = 0; }

            $("#SplashLoadImg").attr("src", iimages[atimg]);
            $("#SplashPreLoadImg").attr("src", iimages[nextimg]); //preload next image
        }

        function onImageLoaded() {
            if (wtimer !== null) {
                clearTimeout(wtimer);
                wtimer = null;
            }

            TweenMax.killTweensOf("#SplashWait");
            TweenMax.to("#SplashWait", 1, { opacity: 0, ease: Quad.easeOut });

            $("#SplashSVGNormal image").attr("xlink:href", iimages[atimg]);

            if ($("#SplashSVG").css("opacity") === "0") {
                TweenMax.to("#SplashSVG", 1, { opacity: 1, ease: Quad.easeOut });
            }

            TweenMax.fromTo("#clipPath2 rect", 3, { attr: { width: "100%" } }, {
                attr: { width: "0%" }, ease: Quint.easeInOut, onComplete: function () {
                    changeText(ikeywords[atkw]);
                    $(".splash-image").attr("xlink:href", iimages[atimg]);

                    atkw++;
                    if (atkw >= ikeywords.length) { atkw = 0; }
            
                    atimg++;
                    if (atimg >= iimages.length) { atimg = 0; }

                    var tl = new TimelineMax({
                        onComplete: function () {
                            setTimeout(function () {
                                nextSlide();
                            }, 1000);
                        }
                    });

                    tl.set("#SplashSVGGray", { opacity: 1 });
                    tl.set("#SplashSVGGreen", { opacity: 1 });
                    tl.set("#clipPath2 rect", { attr: { width: "100%" } });
                    tl.add(TweenMax.fromTo("#clipPath rect", 3, { attr: { x: "101%" } }, { attr: { x: "0%" }, ease: Quint.easeInOut }));
                    tl.add(TweenMax.fromTo("#clipPath2 rect", 3, { attr: { x: "101%" } }, { attr: { x: "0%" }, ease: Quint.easeInOut }), "-=1");
                    tl.set("#SplashSVGGray", { opacity: 0 });

                    /*
                        TweenMax.fromTo("#clipPath rect", 3, { attr: { x: "101%" } }, {
                        attr: { x: "0%" }, ease: Quint.easeInOut, onComplete: function () { 
                            
                            TweenMax.set("#clipPath2 rect", { x: { width: "101%" } });
                            TweenMax.set("#clipPath2 rect", { attr: { width: "100%" } });
                            
                            TweenMax.fromTo("#clipPath2 rect", 3, { attr: { x: "101%" } }, {
                                attr: { x: "0%" }, ease: Quint.easeInOut,
                                onComplete: function () {
                                    TweenMax.set("#SplashSVGGray", { opacity: 0 });

                                    setTimeout(function () {
                                        nextSlide();
                                    }, 1000);
                                }
                            });                        

                    } });
                    */
                }
            });
        }

        function changeText(txt) {
            $(".splash-text tspan").each(function () {
                var textnode = document.createTextNode(txt);

                while (this.firstChild) {
                    this.removeChild(this.firstChild);
                }                

                this.appendChild(textnode);
            });
        }
    }   
    
    function addBlogMenu()
    {
        $("li", "#NavMenu").each(function () {
            var lnks = $(">a", this);

            if (lnks.length > 0) {
                if ($(lnks[0]).attr("href") == "#blog") {
                    if ($("#BlogMenu").length > 0) {
                        $("#BlogMenu").css("display", "block");
                        $("#BlogMenu").appendTo(this);
                    }

                    $(lnks[0]).attr("href", "#");
                }
            }
        });
    }

    function addLegalAreasMenu()
    {
        $("li", "#NavMenu").each(function () {
            var lnks = $(">a", this);

            if (lnks.length > 0) {
                if ($(lnks[0]).attr("href") == "#legalareas") {
                    if ($("#LegalAreasMenu ul").length > 0) {
                        $("#LegalAreasMenu ul").appendTo(this);
                        $("#LegalAreasMenu").remove();
                    }

                    $(lnks[0]).attr("href", "#");
                }
            }
        });
    }    
    
    function stripSizeAttr() {       
        // Remove size attributes that are hardcoded (will be set in css (responsive))
        $("#Content img:not(.alignnone), #Content .wp-caption:not(.alignnone), #Content iframe").removeAttr('width').removeAttr('height').removeAttr('style');
    }

    function checkDropCapLetter() {
        $(".dropcap").each(function () {
            // Get first paragraph contents
            var text = $("p:first-of-type", this).html();

            // Get first letter
            var letter = text.substr(0, 1);

            $(this).addClass('letter-'+letter.toLowerCase());
        });
    }   
    
    function placeDropCap() {
        $(".dropcap").each(function () {
            // Get first paragraph contents
            var text = $("p:first-of-type", this).html();

            // Get first letter
            var letter = text.substr(0, 1);

            // Remove first letter            
            text = text.substr(1, text.length - 1);
            $("p:first-of-type", this).html(text);
            
            var ldiv = "<div class='dropcap-letter'>" + letter + "</div>";

            $("p:first-of-type", this).prepend(ldiv);

            $(this).removeClass("dropcap");
        });
    }   
    
    function onDocumentPosUpdate() {
        positionScrollTopButton();
        bioPicBlur();
    }

    function bioPicBlur() {
        if ($("#BioPicture").length > 0) {
            var scrollTop = $(window).scrollTop();
            var offsetTop = $("#BioPicture").offset().top;
            var mid = $("#BioPicture").outerHeight() / 2;

            if (scrollTop - offsetTop >= mid) {
                $("#BioPicture").addClass("blur");
            }
            else if (scrollTop - offsetTop < mid) {
                $("#BioPicture").removeClass("blur");
            }            
        }    
    }   
    
    function displayTOC() {
        $("#TOCContainer").css({ display: "block" });

        TweenMax.fromTo("#TOCContainer", 0.8, { opacity: 0 }, { opacity: 1, ease: Quad.easeOut });
        TweenMax.staggerFromTo("#PageTOC >ul >li", 0.8, { y: 50, opacity: 0 }, { y: 0, opacity: 1, ease: Quad.easeOut }, 0.1);        
    }   
    
    function setupOfficeSlide()
    {
        if ($("#Office").length > 0) {
            var officescroller = new ElmScroller({
                window: window,
                document: document,
                element: $("#Office .images"),
                elementparent: $("#Office .images-container"),
                direction_x: true,
                scroll_elmclass: ".office-image "
            });
        }    
    }    

    function setupTeamSlide()
    {
        if ($("#Team").length > 0) {
            var teamscroller = new ElmScroller({
                window: window,
                document: document,
                element: $("#Team .images"),
                elementparent: $("#Team .images-container"),
                direction_x: true,
                scroll_elmclass: ".team-image "
            });
        }    
    }    
    
    function positionScrollTopButton() {
        var scrollTop = $(window).scrollTop();
        var mid = $(window).height() / 2;
        var hide_timeout = -1;

        if (scrollTop >= mid) {
            hide_timeout = $("#ScrollTopButton").data("hide_timeout");

            if (hide_timeout !== undefined && hide_timeout !== -1) {
                clearTimeout(hide_timeout);
            }

            $("#ScrollTopButton").prop("hidden", "");
            $("#ScrollTopButton").addClass("show");
        }
        else if (scrollTop < mid) {
            $("#ScrollTopButton").removeClass("show");

            hide_timeout = setTimeout(function () { 
                $("#ScrollTopButton").prop("hidden", "hidden");

                $("#ScrollTopButton").data("hide_timeout", -1);
            }, 1000);

            $("#ScrollTopButton").data("hide_timeout", hide_timeout);            
        }
    }    
    
    function setupNavigation() {
        var nav = new NavMenu({
            window: window,
            document: document,
            elementid: "#NavMenu"
        });
        
        $("#OpenNavButton, a.open-navigation").click(function (e) {
            e.preventDefault();

            if ($("#NavMenu").css("display") === "none" || !$("#Navigation").hasClass("open")) {
                openNavigation("menu");

                $("#NavMenu li:first-of-type a").focus();

                TweenMax.staggerFromTo(nav.getMenuItemsID() + " >ul >li.menu-item", 0.8, { x: 400, z: 0, opacity: 0 }, {
                    x: 0, z: 0.001, opacity: 1, ease: Quint.easeOut,
                    onComplete: function () {
                        nav.redrawMenu();
                    }
                }, 0.1);
            }
        });
        
        $("#CloseNavButton").click(function () {
            closeNavigation();
        });               
    }
    
    function openNavigation(screen) {
        var navclose_timeout = $("#Navigation").data("navclose_timeout");

        if (navclose_timeout !== undefined && navclose_timeout !== -1) {
            clearTimeout(navclose_timeout);
        }

        setNavScreen(screen);
        
        $("#Navigation").addClass("open");
    }
    
    function closeNavigation() {       
        $("#Navigation").removeClass("open");

        if (!$("#NavMenu").prop("hidden"))
        {
            $("#OpenNavButton").focus();
        }
        else if (!$("#SocialBox").prop("hidden")) {
            $("#SocialButton").focus();
        }      
        else if (!$("#SearchBox").prop("hidden")) {
            $("#SearchButton").focus();
        }
        else if (!$("#ShareBox").prop("hidden")) {
            $("#ShareButton").focus();
        }
        else if (!$("#LangBox").prop("hidden")) {
            $("#LangButton").focus();
        }
        
        var navclose_timeout = setTimeout(function () { 
            $(".nav-box").prop("hidden", "hidden");

            $("#Navigation").data("navclose_timeout", -1);
        }, 1000);

        $("#Navigation").data("navclose_timeout", navclose_timeout);        
    }
    
    function setNavScreen(ns) {
        $(".nav-box").prop("hidden", "hidden");

        if (ns.toLowerCase() === "menu")
        {
            $("#NavMenu").prop("hidden", "");
        }
        else if (ns.toLowerCase() === "social") {
            $("#SocialBox").prop("hidden", "");
        }        
        else if (ns.toLowerCase() === "search") {
            $("#SearchBox").prop("hidden", "");
        }
        else if (ns.toLowerCase() === "lang") {
            $("#LangBox").prop("hidden", "");
        }              
        else if (ns.toLowerCase() === "share") {
            $("#ShareBox").prop("hidden", "");
        }        
    }
    
    function setupSocialBox() {
        var socialscroller = new ElmScroller({
            window: window,
            document: document,
            element: $("#SocialBox .nav-items"),
            elementparent: $("#SocialBox .nav-wrap"),
            direction_y: true
        });

        $("#SocialButton, a.open-social-box").click(function (e) {
            e.preventDefault();

            if ($("#SocialBox").css("display") === "none" || !$("#Navigation").hasClass("open")) {
                openNavigation("social");
              
                TweenMax.staggerFromTo("#SocialBox li", 0.8, { x: 400, z: 0, opacity: 0 }, {
                    x: 0, z: 0.001, opacity: 1, ease: Quint.easeOut,
                    onComplete: function () {
                        $("#SocialBox li:first-of-type a").focus();
                        socialscroller.redrawScrollButtons();
                    }
                }, 0.1);
            }
        });       
    }

    function setupLangBox() {
        var langscroller = new ElmScroller({
            window: window,
            document: document,
            element: $("#LangBox .nav-items"),
            elementparent: $("#LangBox .nav-wrap"),
            direction_y: true
        });

        $("#LangButton, a.open-lang-box").click(function (e) {
            e.preventDefault();

            if ($("#LangBox").css("display") === "none" || !$("#Navigation").hasClass("open")) {
                openNavigation("lang");
               
                TweenMax.staggerFromTo("#LangBox .nav-paragraph", 0.8, { x: 400, z: 0, opacity: 0 }, {
                    x: 0, z: 0.001, opacity: 1, ease: Quint.easeOut,
                    onComplete: function () {
                        $("#LangBox a").focus();
                        langscroller.redrawScrollButtons();
                    }
                }, 0.1);
            }
        });       
    }
    
    function setupShareBox() {
        var sharescroller = new ElmScroller({
            window: window,
            document: document,
            element: $("#ShareBox .nav-items"),
            elementparent: $("#ShareBox .nav-wrap"),
            direction_y: true
        });

        $("#ShareButton, a.open-share-box").click(function (e) {
            e.preventDefault();

            if ($("#ShareBox").css("display") === "none" || !$("#Navigation").hasClass("open")) {
                openNavigation("share");
               
                TweenMax.staggerFromTo("#ShareBox .nav-paragraph", 0.8, { x: 400, z: 0, opacity: 0 }, {
                    x: 0, z: 0.001, opacity: 1, ease: Quint.easeOut,
                    onComplete: function () {
                        $("#ShareBox button:first-of-type").focus();
                        sharescroller.redrawScrollButtons();
                    }
                }, 0.1);
            }
        });       
    }
    
    function setupSearchBox() {
        var searchscroller = new ElmScroller({
            window: window,
            document: document,
            element: $("#SearchBox .nav-items"),
            elementparent: $("#SearchBox .nav-wrap"),
            direction_y: true
        });

        $("#SearchButton, a.open-search-box").click(function (e) {
            e.preventDefault();

            if ($("#SearchBox").css("display") === "none" || !$("#Navigation").hasClass("open")) {
                openNavigation("search");
              
                TweenMax.staggerFromTo("#SearchBox .nav-paragraph", 0.8, { x: 400, z: 0, opacity: 0 }, {
                    x: 0, z: 0.001, opacity: 1, ease: Quint.easeOut,
                    onComplete: function () {
                        $("#s", "#SearchInput").focus();
                        searchscroller.redrawScrollButtons();
                    }
                }, 0.1);
            }   
         });
                
        $("#s", "#SearchInput").focus(function () {
            if ($("#s", "#SearchInput").val() === SearchText) {
                $("#s", "#SearchInput").val("");
            }
        });

        $("#s", "#SearchInput").blur(function () {
            if ($("#s", "#SearchInput").val() === "") {
                $("#s", "#SearchInput").val(SearchText);
            }
        });

        $("#PostSearchButton").click(function (ev) {
            if ($("#s", "#SearchInput").val() !== "" && $("#s", "#SearchInput").val() !== SearchText) {
                $("#SearchForm").submit();
            }
            else { $("#s", "#SearchInput").focus(); }
        });

        $("#SearchForm").submit(function () {
            if ($("#s", "#SearchInput").val() === "" || $("#s", "#SearchInput").val() === SearchText) {
                return false;
            }

            return true;
        });         
    }

    function scrollTo(element) {
        TweenMax.to("html, body", 1, { scrollTop: $(element).offset().top, ease: Quint.easeInOut });
    }
    
    function scrollToContainerMid(containerid)
    {
        var ct = $(containerid).offset().top;
        var ch = $(containerid).outerHeight();
        var wh = $(window).height();
        var dh = $(document).height();

        var spos = ct - ((wh - ch) / 2);

        if (spos > (dh - wh)) { spos = dh - wh; }

        TweenMax.to("html, body", 0.5, { scrollTop: spos, ease: Quint.easeOut });
    }

    function checkScreenSize() {
        var mql = window.matchMedia("(orientation: portrait)");
        mql.addListener(adjustViewport);

        $(window).resize(function () { 
            var rmql = window.matchMedia("(orientation: portrait)");
            adjustViewport(rmql);
        });

        adjustViewport(mql);
        
        function adjustViewport(mql) {
            var vp = null;

            if (mql.matches) {
                // Portrait
                if (window.matchMedia("(max-width: 480px)").matches) {
                    vp = document.getElementById('viewport');
                    vp.setAttribute('content', 'width=480');

                    return;
                }       
            }
            else {
                // Landscape
                if (window.matchMedia("(max-width: 768px)").matches) {
                    vp = document.getElementById('viewport');
                    vp.setAttribute('content', 'width=768');

                    return;
                }
            }

            // default        
            vp = document.getElementById('viewport');
            vp.setAttribute('content', 'width=device-width, initial-scale=1.0');
        }      
    }

})();

var schurman_mapstyles = [
                {
                    "featureType": "all",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },                        
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4a4a4a"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "geometry.fill",
                    "stylers": [
                        {
                            "color": "#e4e4e4"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#4a4a4a"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        },
                        {
                            "saturation": "-100"
                        },
                        {
                            "lightness": "0"
                        },
                        {
                            "gamma": "1"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#9fdac6"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#cacaca"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text",
                    "stylers": [
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#828282"
                        }
                    ]
                }
            ];